import React, { Component } from 'react'
import PageHead from '../../components/pageHead';
import Layout from '../../components/Layout';
import '../../sass/_services-details.scss';
import '../../sass/_home.scss';
import TalkData from '../../components/talk-data';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Header from '../../components/header';

export default class index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Header name="services" />
                <PageHead title="AXLR DATA PVT LTD | Software Solutions"></PageHead>
                <Layout>

                    <div className="read-more-axlr">
                        <section className="animejs-code">
                            <Container>
                                <div className="mt-sm-3 pt-sm-5">
                                    <Row>
                                        <Col className="pr-sm-0" md={7}>
                                            <div className="pl-sm-3 pt-5">
                                                <div className="">
                                                    <div className="count">01</div>
                                                    <div className="talk-content count-sd pl-3">What we do?</div>
                                                </div>
                                                <div className="big-heading pt-sm-2 get-0909">Analytics</div>
                                                <div className="main-content pt-sm-5">We analyze. We predict. We optimize. With us, your data gives you meaningful information and actionable insights.</div>
                                            </div>
                                        </Col>
                                        <Col className="text-center">
                                            <video className="width-vedio" autoPlay loop playsInline muted>
                                                <source src={`${publicRuntimeConfig.staticFolder}/images/svg-vedio.mp4`} type="video/mp4" />
                                            </video>
                                        </Col>
                                    </Row>
                                </div>
                                <br />
                                <br />
                            </Container>
                        </section>

                        <section className="" id="Contextual-Dashboard">
                            <Container className="pt-sm-5">
                                <Row>
                                    <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Contextual_Dashboard-s.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Contextual Dashboard</div>
                                        <div>
                                            <input type="checkbox" class="read-more-state" id="post-2" />
                                            <div className="spectial-content pt-sm-4 read-more-wrap">
                                                Unlike us humans, businesses are functioning round the clock - a customer might be
                                                interacting with them, a fierce competitor trying to understand the secret sauce,
                                                a vendor burning the midnight oil. In order to keep you ahead of the curve,
                                           <span class="read-more-target"> we bring you insights crucial to your business in the form of contextual dashboards.
                                                                            Whether you are an online business or a manufacturing company, we extract key metrics
                                                                             from different processes and churn all that data to produce meaningful information
                                              that can help you improve your bottom line</span>
                                            </div>
                                            <label for="post-2" class="read-more-trigger"></label>
                                        </div>
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Data Integration</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Data Quality</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Data Wrangling</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Data Management</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Data Warehousing</div>
                                                </Col>
                                            </Row>

                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Predictive-Analytics">
                            <Container className="mt-5 pt-sm-5">
                                <Row>
                                    <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Predictive_analytics-s.svg`} alt="dev-group" className="mt-3 pt-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Predictive Analytics</div>
                                        <div>
                                            <input type="checkbox" class="read-more-state" id="post-3" />
                                            <div className="spectial-content pt-sm-4 read-more-wrap">
                                                We leverage historical data to give businesses an added advantage. How? We use an organization's
                                                past and current data to reliably forecast trends and behaviors milliseconds, days, or years
                                                into the future, with a significant degree of precision. We utilize a wide range of methods and
                                          technologies, including big data, data mining, statistical modeling, <span class="read-more-target">machine learning,
                                                                             and assorted
                                                                            mathematical operations to sift through historical and current data to detect trends and forecast events
                                                                            and conditions that can occur at a specific time, based on the parameters provided. This enables organizations
                                                                            to assess the promise or risk under a certain set of conditions, thus paving the way for informed decision making
                                          across various categories of business operations</span>
                                            </div>
                                            <label for="post-3" class="read-more-trigger"></label>
                                        </div>
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Customer Lifetime Value Model</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Customer Segmentation Model</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Predictive Maintenance Model</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Quality Assurance Model</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Sales Forecast Model</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Predictive_analytics-s.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Machine-Learning">
                            <Container className="mt-5 pt-sm-5">
                                <Row>
                                    <Col className="text-center">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/Machine_Learning-s.svg`} alt="dev-group" className="mt-3 pt-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Machine Learning</div>
                                        <div>
                                            <input type="checkbox" class="read-more-state" id="post-4" />
                                            <div className="spectial-content pt-sm-4 read-more-wrap">
                                                Most businesses operate with several complex constraints ranging from a variety
                                                of systems/ machines/ processes involved, supply and demand, availability of resources,
                                        and many more. We work with organizations to untangle these challenges. <span class="read-more-target"> We leverage advanced
                                                                                mathematical algorithms to build models that uncover connections, enabling organizations to
                                                                                make better decisions without human intervention. Our methods have led businesses to solve problems
                                                                                that have stumped traditional analytical approaches, such as those involving new sources of unstructured
                                        data, including graphics, sound, videos, and other high-dimensional, machine-generated data</span>
                                            </div>
                                            <label for="post-4" class="read-more-trigger"></label>
                                        </div>
                                        <div className="pt-4">

                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Supervised Learning</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Unsupervised Learning</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Semisupervised Learning</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Reinforcement Learning</div>
                                                </Col>
                                            </Row>
                                            {/* <Row>
                                                <Col md={1} xs={1}>
                                                    <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                        <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                    </ScrollAnimation>
                                                </Col>
                                                <Col>
                                                    <div className="spectial-content font-sps E7373ERmb">Data Warehousing</div>
                                                </Col>
                                            </Row> */}
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <section className="" id="Natural-Language-Processing">
                            <Container className="mt-5 pt-sm-5">
                                <Row>
                                    <Col className="text-center mobile">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                {/* <div className="spectial-content pt-sm-5 mt-sm-5 ta9990pj">We don't make users</div> */}
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/NLP-s.svg`} alt="dev-group" className="mt-3 pt-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                    <Col md>
                                        <div className="main-heading-home pt-4">Natural Language Processing</div>
                                        <div>
                                            <input type="checkbox" class="read-more-state" id="post-5" />
                                            <div className="spectial-content pt-sm-4 read-more-wrap">
                                                Your customers may speak and write in English, Chinese, or Hindi. We bring advanced NLP methods
                                                that enable business communication in any language and scales other language-related tasks.
                                                We use different techniques, such as tokenization and parsing, lemmatization/stemming,
                                                part-of-speech tagging, language detection and identification of semantic relationships, for
                                        interpreting human language, ranging <span class="read-more-target">from statistical and machine learning methods to rules-based
                                                                                and algorithmic approaches. We use these broad arrays of approaches in order to enable a wide variety
                                                                                of practical applications. In short, we use NLP tasks to break down language into shorter, elemental
                                                                                pieces, try to understand relationships between the pieces and explore how the pieces work together
                                        to create meaning for your business</span>
                                            </div>
                                            <label for="post-5" class="read-more-trigger"></label>
                                        </div>
                                    </Col>
                                    <Col className="text-center desktop">
                                        <ScrollAnimation animateIn="zoomIn">
                                            <div>
                                                {/* <div className="spectial-content pt-sm-5 mt-sm-5 ta9990pj">We don't make users</div> */}
                                                <img src={`${publicRuntimeConfig.staticFolder}/images/NLP-s.svg`} alt="dev-group" className="mt-sm-3 pt-sm-2 w-100" />
                                            </div>
                                        </ScrollAnimation>
                                    </Col>
                                </Row>
                                <Row>
                                                <Col md>
                                                    <div className="pt-4">
                                                        <Row>
                                                            <Col md={1} xs={1}>
                                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                                </ScrollAnimation>
                                                            </Col>
                                                            <Col>
                                                                <div className="spectial-content font-sps E7373ERmb">Content Categorization</div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={1} xs={1}>
                                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                                </ScrollAnimation>
                                                            </Col>
                                                            <Col>
                                                                <div className="spectial-content font-sps E7373ERmb">Topic Discovery and Modeling</div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={1} xs={1}>
                                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                                </ScrollAnimation>
                                                            </Col>
                                                            <Col>
                                                                <div className="spectial-content font-sps E7373ERmb">Contextual Extraction</div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={1} xs={1}>
                                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                                </ScrollAnimation>
                                                            </Col>
                                                            <Col>
                                                                <div className="spectial-content font-sps E7373ERmb">Sentiment Analysis</div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className="pt-4">
                                                        <Row>
                                                            <Col md={1} xs={1}>
                                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                                </ScrollAnimation>
                                                            </Col>
                                                            <Col>
                                                                <div className="spectial-content font-sps E7373ERmb">Speech-to-text and text-to-speech conversion</div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={1} xs={1}>
                                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                                </ScrollAnimation>
                                                            </Col>
                                                            <Col>
                                                                <div className="spectial-content font-sps E7373ERmb">Document Summarization</div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={1} xs={1}>
                                                                <ScrollAnimation animation='wobble' initiallyVisible={true}>
                                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/discover-arrow.svg`} alt="discover-arrow" className="mt-2" />
                                                                </ScrollAnimation>
                                                            </Col>
                                                            <Col>
                                                                <div className="spectial-content font-sps E7373ERmb">Machine Translation</div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                            </Container>
                        </section>
                        <TalkData title={<span>Got some data?<br /> Let us churn!</span>} subtitle="" />
                    </div>

                </Layout>
                <style>
                    {`
                    body{
                        overflow-x: hidden
                    }
                    .ta9990pj{
                        font-size: 30px !important;
                        font-weight: 900;
                    }
                    `}
                </style>
            </div>
        )
    }
}
